export const tableOption = {
    border: true,
    index: false,
    stripe: true,
    align:'center',
    menuAlign:'center',
    editBtn: false,
    addBtn: false,
    delBtn: false,
    refreshBtn: false,
    columnBtn: false,
    column: [
    {
        label: 'ID',
        prop: 'id',
        hide: true,
        editDisabled: true,
    },{
        label: '行为描述',
        prop: 'actionDescription',
        editDisabled: true,
    },{
        label: '条件',
        prop: 'condition',
        editVisdiplay: false
    },{
        label: '条件',
        prop: 'additional',
        hide: true,
    },{
        label:'积分值',
        prop:'rewardValue',
        sortable:true,
    },{
        label:'每日上限',
        prop:'dailyLimit',
        solt: true
    },{
        label:'是否启用',
        prop:'isEnabled',
        width: 100,
        editVisdiplay: false,
        type: 'Select',
        dicData: [{
            label: '已启用',
            value: true
          }, {
            label: '已禁用',
            value: false
          }]
    },{
        label:'更新时间',
        prop:'updatedTime',
        type: 'datetime',
        sortable:true,
        format: 'yyyy-MM-dd HH:mm',
        valueFormat: 'yyyy-MM-dd HH:mm:ss',
        editVisdiplay: false
    }]
  }
  